import styled from "styled-components";
import { DisplaySmall, Body, spacing } from "@conserveit/blocks";

export const RuleName = styled(DisplaySmall)`
  margin-bottom: ${spacing.default};
`;

export const CheckboxWrap = styled.div`
  margin-bottom: ${spacing.default};
`;

export const FieldLabel = styled(Body)`
  margin-bottom: ${spacing.tight};
  font-weight: 700;
`;
